module.exports = __webpack_public_path__ + "static/media/Harmonizer Modeler High Gain VR.fe6d009.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/modeler/Harmonizer Modeler High Gain VR.mp3
// module id = YGn3
// module chunks = 12